module.exports = __webpack_public_path__ + "img/floorplan-drawings.69b3bc30.png";